import { render, staticRenderFns } from "./InitTenantDialog.vue?vue&type=template&id=6c34b05c&scoped=true"
import script from "./InitTenantDialog.vue?vue&type=script&lang=js"
export * from "./InitTenantDialog.vue?vue&type=script&lang=js"
import style0 from "./InitTenantDialog.vue?vue&type=style&index=0&id=6c34b05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34b05c",
  null
  
)

export default component.exports